module.exports = __webpack_public_path__ + "static/media/sales.fe8535d6.svg";